module.exports = __webpack_public_path__ + "static/media/VU_mask.c18e95c4.png";